(function () {
  // Card video controls (play/pause, mute/unmute); the cards slider itself is
  // handled by the shared initSectionSliderLayout in global.js.
  const initTestimonials = (section) => {
    if (!section?.classList?.contains("testimonials-section")) return;

    if (section._testimonialsCleanup) {
      section._testimonialsCleanup();
      section._testimonialsCleanup = null;
    }

    const videoCards = section.querySelectorAll(".testimonials-card--video");
    if (!videoCards.length) return;

    const controller = new AbortController();
    const observers = [];

    const getVideo = (card) => card.querySelector("video.js-video");

    const playVideo = (card) => {
      const video = getVideo(card);
      if (!video) return;
      video.play().catch(() => {});
      card.classList.add("is-playing");
    };

    const pauseVideo = (card) => {
      const video = getVideo(card);
      if (!video) return;
      video.pause();
      card.classList.remove("is-playing");
    };

    section.addEventListener(
      "click",
      (event) => {
        const playPauseBtn = event.target.closest(".js-video-play-pause");
        const soundBtn = event.target.closest(".js-video-sound");
        if (!playPauseBtn && !soundBtn) return;

        const card = (playPauseBtn || soundBtn).closest(
          ".testimonials-card--video"
        );
        if (!card) return;

        const video = getVideo(card);
        if (!video) return;

        if (playPauseBtn) {
          if (card.classList.contains("is-playing")) {
            card.dataset.userPaused = "true";
            pauseVideo(card);
          } else {
            delete card.dataset.userPaused;
            playVideo(card);
          }
          return;
        }

        if (card.classList.contains("is-muted")) {
          video.muted = false;
          card.classList.remove("is-muted");
        } else {
          video.muted = true;
          card.classList.add("is-muted");
        }
      },
      { signal: controller.signal }
    );

    videoCards.forEach((card) => {
      // Only the vertical axis should gate playback: without the horizontal
      // slack a card sliding past the viewport edge pauses and replays on every
      // swipe, which flickers the video and its controls (worst in Safari).
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (card.dataset.userPaused !== "true") playVideo(card);
            } else if (card.classList.contains("is-playing")) {
              pauseVideo(card);
            }
          });
        },
        { rootMargin: "0px 100% 0px 100%" }
      );

      observer.observe(card);
      observers.push(observer);
    });

    section._testimonialsCleanup = () => {
      controller.abort();
      observers.forEach((observer) => observer.disconnect());
    };
  };

  initTestimonials(document.currentScript.parentElement);

  if (!window.__themeTestimonialsEvents) {
    window.__themeTestimonialsEvents = true;

    document.addEventListener("shopify:section:load", (event) => {
      initTestimonials(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      const section = event.target;
      if (section?._testimonialsCleanup) {
        section._testimonialsCleanup();
        section._testimonialsCleanup = null;
      }
    });
  }
})();
